<div class="d-flex flex-column gap-4">
  <div class="file-list-label" i18n>Submitted Files</div>
  <div *ngIf="files?.length; else noFiles">
    <div class="d-flex flex-column gap-3">
      <app-file-list-item
        *ngFor="let file of files"
        [fileName]="file.attachment.fileName"
        [fileSizeInBytes]="file.attachment.fileSize"
        [previewUrl]="file.attachment.links | attachmentLink"
        action="download"
        class="w-100" />
    </div>
  </div>
</div>
<ng-template #noFiles>
  <div class="no-files" i18n>No submitted files.</div>
</ng-template>
